module.exports = __webpack_public_path__ + "static/media/ineuron-logo.fe835e4f.png";